import { Subscription } from 'dva';
import type { CollectionManagerType, ChangeAction } from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { siderEffects } from './siderEffects';
import { versionEffects } from './versionEffects';
import { infoEffects } from './infoEffects';

export type { CollectionManagerState } from './types';
export * from './types';

const Model: CollectionManagerType = {
  namespace: 'collectionManager',
  state: initialState,
  effects: {
    ...pageEffects,
    ...siderEffects,
    ...versionEffects,
    ...infoEffects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;
